import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@material-ui/icons/Add';
import MaterialTable from 'material-table';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Alert, Button, ButtonToolbar, Collapse } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core';
import SmartCard from '../../../shared/components/SmartCard';
import columns from './ColumnsAlertConfiguration';
import Select from '../../../shared/components/form/Select';
import { onShowAlert } from '../../../shared/utils/smartutils';
import materialTableIcons from '../../../shared/utils/materialTableIcons';

const AlertConfiguration = (props) => {
  const { t, alertsConfigurations, accountId, onConfirm, alerts } = props;

  const [selectedAlert, setSelectAlert] = useState({});
  const [alertsConfList, setAlertsConfList] = useState([]);
  const [notificationAlert, setNotificationAlert] = useState({
    status: false,
    title: '',
    color: '',
  });

  const alertSelectChange = (values) => {
    const { value, label, ...itemRef } = values;
    setSelectAlert({ ...itemRef, accountId });
  };

  const removeAlertClick = (evt, rowData) => {
    const found = alertsConfList.findIndex((element) => element === rowData);
    const updatedList = [...alertsConfList];
    updatedList.splice(found, 1);
    setAlertsConfList(updatedList);
  };

  const validateAlertToAdd = (alertToAdd) => {
    const itemFound = alertsConfList.find(
      (item) => item.alertDay === alertToAdd.alertDay
    );
    if (itemFound) {
      return false;
    }
    return true;
  };

  const onAddAlertClick = () => {
    const updatedList = [...alertsConfList, selectedAlert];
    const alertToAdd = selectedAlert;
    if (Object.keys(selectedAlert).length !== 0) {
      const valid = validateAlertToAdd(alertToAdd);

      if (valid) {
        setAlertsConfList(updatedList);
      } else {
        onShowAlert(
          'warning',
          'errors.title',
          'answers.validation.alert-already-registered',
          setNotificationAlert
        );
      }
    } else {
      onShowAlert(
        'warning',
        'errors.title',
        'answers.validation.select-alert',
        setNotificationAlert
      );
    }
  };

  const compareOnConfirm = () => {
    const originalList = alertsConfigurations.map((item) => {
      if (item.tableData) {
        const { tableData, ...itemRef } = item;
        return itemRef;
      }
      return item;
    });
    const newList = alertsConfList.map((item) => {
      if (item.tableData) {
        const { tableData, ...itemRef } = item;
        return itemRef;
      }
      return item;
    });

    let changed = false;
    if (newList.length === originalList.length) {
      originalList.forEach((itemA) => {
        const itemIndex = newList.findIndex(
          (intemB) => itemA.alertDay === intemB.alertDay
        );
        if (itemIndex === -1) {
          changed = true;
        }
      });
    } else {
      changed = true;
    }
    onConfirm(newList, changed);
  };

  useEffect(() => {
    setAlertsConfList(alertsConfigurations);
    return () => {
      setAlertsConfList([]);
    };
  }, []);

  return (
    <MuiThemeProvider>
      <>
        <SmartCard>
          <form className="form">
            <div className="form__form-group--2_columns">
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('general.send-expiration')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name="alerts"
                    type="text"
                    component={Select}
                    options={alerts}
                    placeholder={t('account.placeholders.select')}
                    onChange={(value) => alertSelectChange(value)}
                  />
                </div>
              </div>
              <div className="d-flex flex-grow-1 align-items-center pl-3">
                <IconButton
                  className="icon-button"
                  aria-label="add"
                  onClick={onAddAlertClick}
                >
                  <AddIcon />
                </IconButton>
              </div>
            </div>
          </form>
          <Collapse isOpen={notificationAlert.status}>
            <Alert color={notificationAlert.color}>
              {t(notificationAlert.message)}
            </Alert>
          </Collapse>
          <div className="form__form-group">
            <MaterialTable
              data={alertsConfList}
              columns={columns(t)}
              icons={materialTableIcons}
              actions={[
                {
                  icon: 'delete',
                  tooltip: t('general.tables.delete_registry'),
                  onClick: (evt, rowData) => removeAlertClick(evt, rowData),
                },
              ]}
              options={{
                paging: false,
                showTitle: false,
                search: false,
                toolbar: false,
                actionsColumnIndex: 8,
                headerStyle: {
                  zIndex: 0,
                },
              }}
              localization={{
                header: {
                  actions: t('general.tables.actions'),
                },
                body: {
                  emptyDataSourceMessage: t(
                    'general.tables.no-data-to-display'
                  ),
                },
              }}
            />
          </div>
          <ButtonToolbar className="form__button-toolbar">
            <Button color="success" onClick={compareOnConfirm}>
              {t('general.save')}
            </Button>
          </ButtonToolbar>
        </SmartCard>
      </>
    </MuiThemeProvider>
  );
};

AlertConfiguration.propTypes = {
  t: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  onConfirm: PropTypes.func.isRequired,
  alerts: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  alertsConfigurations: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
};

export default reduxForm({
  form: 'alertConfigurationForm',
})(withTranslation('common')(AlertConfiguration));
